// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Scalars = require("../../../scalars/Scalars.bs.js");
var FeaturesV3 = require("../../../reason/featureFlipper/FeaturesV3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var UserSession = require("../../../reason/common/UserSession/UserSession.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Form__Validators = require("../../../reason/common/Form/Form__Validators.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
var PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
var PropertyWizardFormRelayValidatorsDescription_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsDescription_draft_graphql.bs.js");
var PropertyWizardFormRelayValidatorsDescription_formState_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsDescription_formState_graphql.bs.js");
var PropertyWizardFormRelayValidatorsDescriptionMessage_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsDescriptionMessage_draft_graphql.bs.js");
var PropertyWizardFormRelayValidatorsDescriptionSubject_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsDescriptionSubject_draft_graphql.bs.js");
var PropertyWizardFormRelayValidatorsDescriptionWebsite_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsDescriptionWebsite_draft_graphql.bs.js");
var PropertyWizardFormRelayValidatorsDescriptionDescription_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsDescriptionDescription_draft_graphql.bs.js");
var PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_draft_graphql.bs.js");
var PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_formState_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_formState_graphql.bs.js");

var convertFragment = PropertyWizardFormRelayValidatorsDescriptionSubject_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsDescriptionSubject_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsDescriptionSubject_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsDescriptionSubject_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsDescriptionSubject_draft_graphql.node, convertFragment, fRef);
}

var DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function useIsValid(draft) {
  var draft$1 = use(draft);
  var subject = PropertyWizardRelayUtils.FormUtils.noneIfEmpty(draft$1.subject);
  if (subject !== undefined) {
    if (subject.length > 150) {
      return {
              NAME: "Error",
              VAL: "Longer than " + ((150).toString() + " characters! Keep this field short and concise")
            };
    } else {
      return "Valid";
    }
  } else {
    return {
            NAME: "Error",
            VAL: "is required"
          };
  }
}

var Subject = {
  DraftFragment: DraftFragment,
  subjectLengthLimit: 150,
  useIsValid: useIsValid
};

var convertFragment$1 = PropertyWizardFormRelayValidatorsDescriptionMessage_draft_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsDescriptionMessage_draft_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsDescriptionMessage_draft_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsDescriptionMessage_draft_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsDescriptionMessage_draft_graphql.node, convertFragment$1, fRef);
}

var DraftFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function useIsValid$1(draft) {
  var match = PropertyWizardFormRelay.Context.use();
  var draft$1 = use$1(draft);
  var tmp = match.mode;
  if (typeof tmp !== "object") {
    return "Valid";
  }
  if (tmp.TAG !== "Rebroadcast") {
    return "Valid";
  }
  var match$1 = PropertyWizardRelayUtils.FormUtils.noneIfEmpty(draft$1.message);
  if (match$1 !== undefined) {
    return "Valid";
  } else {
    return {
            NAME: "Error",
            VAL: "is required"
          };
  }
}

var Message = {
  DraftFragment: DraftFragment$1,
  useIsValid: useIsValid$1
};

var convertFragment$2 = PropertyWizardFormRelayValidatorsDescriptionDescription_draft_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsDescriptionDescription_draft_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsDescriptionDescription_draft_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsDescriptionDescription_draft_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsDescriptionDescription_draft_graphql.node, convertFragment$2, fRef);
}

var DraftFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function useIsValid$2(draft) {
  var draft$1 = use$2(draft);
  var agent = UserSession.useAgentInfo();
  var personalInfoValidationFlag = FeaturesV3.useFeatureFlipper("ValidatePersonalInfoInDescription");
  var personalInfoValidationEnabled = personalInfoValidationFlag === "on";
  var match = PropertyWizardRelayUtils.FormUtils.noneIfEmpty(draft$1.draftProperty.description);
  if (match === undefined) {
    return {
            NAME: "Error",
            VAL: "is required"
          };
  }
  if (!personalInfoValidationEnabled) {
    return "Valid";
  }
  var match$1 = agent.membership.account.owner;
  if (match$1 === undefined) {
    return {
            NAME: "Error",
            VAL: ""
          };
  }
  var owner = match$1.agent;
  var str = Form__Validators.PersonalInfoValidation.validate({
        id: agent.id,
        firstName: agent.firstName,
        lastName: agent.lastName,
        displayName: agent.displayName
      }, {
        id: owner.id,
        firstName: owner.firstName,
        lastName: owner.lastName,
        displayName: owner.displayName
      }, match);
  if (str.TAG === "Ok") {
    return "Valid";
  } else {
    return {
            NAME: "Error",
            VAL: "Personal or contact information should only be in the \"Message to TAN colleagues\" field below." + Core__Option.getOr(Core__Option.map(str._0, (function (m) {
                        return " Please remove \"" + m + "\" from the description.";
                      })), "")
          };
  }
}

var Description = {
  DraftFragment: DraftFragment$2,
  useIsValid: useIsValid$2
};

var convertFragment$3 = PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_draft_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_draft_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_draft_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_draft_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_draft_graphql.node, convertFragment$3, fRef);
}

var DraftFragment$3 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

var convertFragment$4 = PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_formState_graphql.Internal.convertFragment;

function waitForFragmentData$4(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_formState_graphql.node, convertFragment$4, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_formState_graphql.node, convertFragment$4, fRef);
}

function useOpt$4(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_formState_graphql.node, convertFragment$4);
}

function readResolverFragment$4(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_formState_graphql.node, convertFragment$4, fRef);
}

var FormStateFragment_localDraftGeocodingStatus_decode = PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_formState_graphql.Utils.localDraftGeocodingStatus_decode;

var FormStateFragment_localDraftGeocodingStatus_fromString = PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_formState_graphql.Utils.localDraftGeocodingStatus_fromString;

var FormStateFragment = {
  localDraftGeocodingStatus_decode: FormStateFragment_localDraftGeocodingStatus_decode,
  localDraftGeocodingStatus_fromString: FormStateFragment_localDraftGeocodingStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$4,
  waitForFragmentData: waitForFragmentData$4,
  use: use$4,
  useOpt: useOpt$4,
  readResolverFragment: readResolverFragment$4
};

function useIsValid$3(draft, formState) {
  var draft$1 = use$3(draft);
  var formState$1 = use$4(formState);
  var match = draft$1.draftProperty;
  var match$1 = formState$1.geocodingStatus;
  var address = match.address;
  switch (match$1) {
    case "NotCalled" :
    case "Called" :
        return ;
    case "Error" :
        return {
                NAME: "Error",
                VAL: "There was an error validating the address. Please check Key Facts"
              };
    default:
      if (address === undefined) {
        return ;
      }
      var displayNeighborhood = match.displayNeighborhood;
      if (displayNeighborhood === undefined) {
        return ;
      }
      var selectedArea = match.selectedArea;
      if (selectedArea !== undefined) {
        if (formState$1.displayNeighborhoods.some(function (dn) {
                return dn.id === displayNeighborhood.id;
              })) {
          return "Valid";
        } else {
          return {
                  NAME: "Error",
                  VAL: displayNeighborhood.label + " is not a valid display neighborhood for " + address + ", " + selectedArea.label
                };
        }
      } else {
        return ;
      }
  }
}

var DisplayNeighborhood = {
  DraftFragment: DraftFragment$3,
  FormStateFragment: FormStateFragment,
  useIsValid: useIsValid$3
};

var convertFragment$5 = PropertyWizardFormRelayValidatorsDescriptionWebsite_draft_graphql.Internal.convertFragment;

function waitForFragmentData$5(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsDescriptionWebsite_draft_graphql.node, convertFragment$5, fRef);
}

function use$5(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsDescriptionWebsite_draft_graphql.node, convertFragment$5, fRef);
}

function useOpt$5(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsDescriptionWebsite_draft_graphql.node, convertFragment$5);
}

function readResolverFragment$5(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsDescriptionWebsite_draft_graphql.node, convertFragment$5, fRef);
}

var DraftFragment$4 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$5,
  waitForFragmentData: waitForFragmentData$5,
  use: use$5,
  useOpt: useOpt$5,
  readResolverFragment: readResolverFragment$5
};

function useIsValid$4(draft) {
  var draft$1 = use$5(draft);
  var website = PropertyWizardRelayUtils.FormUtils.noneIfEmpty(draft$1.draftProperty.website);
  if (website === undefined) {
    return ;
  }
  var match = Scalars.$$URL.fromString(website);
  if (match.TAG === "Ok") {
    return "Valid";
  } else {
    return {
            NAME: "Error",
            VAL: "Please enter a valid URL"
          };
  }
}

var Website = {
  DraftFragment: DraftFragment$4,
  useIsValid: useIsValid$4
};

var convertFragment$6 = PropertyWizardFormRelayValidatorsDescription_draft_graphql.Internal.convertFragment;

function waitForFragmentData$6(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsDescription_draft_graphql.node, convertFragment$6, fRef);
}

function use$6(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsDescription_draft_graphql.node, convertFragment$6, fRef);
}

function useOpt$6(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsDescription_draft_graphql.node, convertFragment$6);
}

function readResolverFragment$6(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsDescription_draft_graphql.node, convertFragment$6, fRef);
}

var DraftFragment$5 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$6,
  waitForFragmentData: waitForFragmentData$6,
  use: use$6,
  useOpt: useOpt$6,
  readResolverFragment: readResolverFragment$6
};

var convertFragment$7 = PropertyWizardFormRelayValidatorsDescription_formState_graphql.Internal.convertFragment;

function waitForFragmentData$7(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsDescription_formState_graphql.node, convertFragment$7, fRef);
}

function use$7(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsDescription_formState_graphql.node, convertFragment$7, fRef);
}

function useOpt$7(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsDescription_formState_graphql.node, convertFragment$7);
}

function readResolverFragment$7(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsDescription_formState_graphql.node, convertFragment$7, fRef);
}

var FormStateFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$7,
  waitForFragmentData: waitForFragmentData$7,
  use: use$7,
  useOpt: useOpt$7,
  readResolverFragment: readResolverFragment$7
};

function use$8(draft, formState) {
  var draft$1 = use$6(draft);
  var formState$1 = use$7(formState);
  var subjectIsValid = useIsValid(draft$1.fragmentRefs);
  var displayNeighborhoodIsValid = useIsValid$3(draft$1.fragmentRefs, formState$1.fragmentRefs);
  var descriptionIsValid = useIsValid$2(draft$1.fragmentRefs);
  var messageIsValid = useIsValid$1(draft$1.fragmentRefs);
  var websiteIsValid = useIsValid$4(draft$1.fragmentRefs);
  return PropertyWizardRelayUtils.FormUtils.allValid([
              subjectIsValid,
              displayNeighborhoodIsValid,
              descriptionIsValid,
              messageIsValid,
              websiteIsValid
            ]);
}

var FormUtils;

exports.FormUtils = FormUtils;
exports.Subject = Subject;
exports.Message = Message;
exports.Description = Description;
exports.DisplayNeighborhood = DisplayNeighborhood;
exports.Website = Website;
exports.DraftFragment = DraftFragment$5;
exports.FormStateFragment = FormStateFragment$1;
exports.use = use$8;
/* Scalars Not a pure module */
